// sourceServiceProcedureOrganizationRepository.js
import { request } from './repository';

const sourceServiceProcedureOrganizationRepository = {
    getSourceProcedureOrganizations(source_procedure_id) {
        return request.get(`source-procedure/${source_procedure_id}/organizations`);
    },

    findByOrganizationIdAndSourceProcedureId({ organization_id, source_procedure_id }) {
        return request.get(
            `source-procedure-organization/find-by-organization-and-source-procedure/${organization_id}/${source_procedure_id}`
        );
    },

    updateSourceProcedureOrganization(source_procedure_id, payload) {
        return request.put(`source-procedure/${source_procedure_id}/organizations`, payload);
    },

    deleteSourceProcedureOrganization(source_procedure_id, organization_id) {
        return request.delete(`source-procedure/${source_procedure_id}/organizations/${organization_id}`);
    },
};

export default sourceServiceProcedureOrganizationRepository;
